<template>
  <div class="pb-4 cblog-cont">
    <div class="cblog-col p-0">
      <div class="cblog-head ">
        <h3>Restaurant Blog</h3></div>
      <div v-if="contentData" class="cblog-news-cont">
        <blog-page v-for="(page) in blog_contents" :key="page.id" :blog="page"/>
      </div>
      <div class="pagination" v-if="maxItems > itemCount">

        <div @click="pageFirst" class="no-border"><i class="fas fa-angle-double-left"></i></div>
        <div @click="pageDown" class="no-border"><i class="fas fa-angle-left"></i></div>
        <div class="cursor-pointer" @click="paginate_click(page, index)" v-for="(page, index) in split_pagination" :key="index" :class="page === pageCount + 1 ? 'active' : ''">{{page}}</div>
        <div @click="pageUp" class="no-border"><i class="fas fa-angle-right"></i></div>
        <div @click="pageLast" class="no-border"><i class="fas fa-angle-double-right"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogPage from './BlogPage'
export default {
  name: 'BlogContentPages',
  props: {
    perPage: {
      type: Number
    }
  },
  data () {
    return {
      pageCount: 0,
      maxItems: 0,
      contentData: null,
      refresh: false
    }
  },
  beforeMount () {
    this.getContentList()
  },
  mounted () {
  },
  components: {
    BlogPage
  },
  computed: {
    itemCount () {
      if (this.isMobile)  {
        return this.perPage
      } else {
        return this.perPage
      }
    },
    blog_contents () {
      return this.contentData.data
    },
    isMobile () {
      return this.$store.state.api.isMobile
    },
    split_pagination () {
      const arr = this.pageArray
      const result = []
      if (arr.length > 5) {
        if (this.pageCount < arr.length - 2 && this.pageCount > 1) {
          result.push('...')
          result.push(this.pageCount)
          result.push(this.pageCount + 1)
          result.push(this.pageCount + 2)
          result.push('...')
          //result.push(arr.length)
        } else if (this.pageCount < 3) {
          result.push(arr[0])
          result.push(arr[1])
          result.push(arr[2])
          result.push('...')
          result.push(arr.length)
        } else {
          result.push(arr[0])
          result.push('...')
          result.push(arr.length - 2)
          result.push(arr.length - 1)
          result.push(arr.length)
        }
        return result
      } else {
        return arr
      }
    },

    pageArray () {
      //const array = JSON.parse(JSON.stringify(this.all_restaurants))
      const page_array = []
      let i = 0
      const max_page = Math.floor(this.maxItems / this.itemCount)
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      const kalan = Math.floor(this.maxItems % this.itemCount)
      if (kalan > 0) {
        page_array.push(max_page + 1)
      }
      return page_array
    }
  },
  watch: {
    refresh () {
      if (this.refresh) {
        const self = this
        setTimeout(() => {
          self.refresh = false
        }, 0)
        //self.$refs.rest_list.scrollIntoView({ behavior: 'smooth' })
      }
    },
    pageCount () {
      this.getContentList()
    }
  },
  methods: {
    pageDoubleUp () {
      if (this.pageCount < this.pageArray.length - 3) {
        this.pageCount += 3
      }
    },
    pageFirst () {
      this.pageCount = 0
    },
    pageLast () {
      this.pageCount = this.pageArray.length - 1
    },
    pageDoubleDown () {
      if (this.pageCount !== 0 && this.pageCount !== 1) {
        this.pageCount -= 3
      }
    },
    pageUp () {
      if (this.pageCount < this.pageArray.length - 1) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    paginate_click (page, index) {
      if (page === '...') {
        if (index === this.split_pagination.length - 2 || index === this.split_pagination.length - 1) {
          this.pageDoubleUp()
        } else {
          this.pageDoubleDown()
        }
      } else {
        this.pageCount = page - 1
      }
    },
    contentClicked (id) {
      this.$router.push({name: 'promotion', params: {content_id: id }}).catch(() => {})
    },
    getContentList () {

      this.$vs.loading()

      const payload = {
        contentType: 'blog',
        isHome: 1,
        page: this.pageCount + 1,
        limit: this.perPage
      }

      this.$store.dispatch('api/contentList', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.contentData = response.data
          this.maxItems = this.contentData.total
          this.refresh = true
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    }
  }
}
</script>

<style lang="scss">
.page-content-image {
  height: 250px;
  width: 100%;
  border-radius: 10px;


  .vx-card__body {
    padding: 0 !important;
  }
}

.page-image-wrapper {
  width: 100%;
  height: 222px;
  background-size:cover;
  background-position: center;

}

@media (min-width: 860px) {

  .page-image-wrapper {
    height: 222px;
  }
}
</style>
